import { render, staticRenderFns } from "./EventForm.vue?vue&type=template&id=91b944b2&scoped=true&"
import script from "./EventForm.vue?vue&type=script&lang=js&"
export * from "./EventForm.vue?vue&type=script&lang=js&"
import style0 from "./EventForm.vue?vue&type=style&index=0&id=91b944b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b944b2",
  null
  
)

export default component.exports